import React from 'react';

const FilterBarSkeleton = () => {
  return (
    <>
      <div className="d-flex p-3 mb-2 ml-2" style={{ width: "100%" }}>
        {/* Placeholder for DatePicker */}
        <div className="shimmer" style={{ width: "200px", height: "32px" }}></div>

        {/* Placeholder for Select Dropdown */}
        <div className="ms-3 shimmer" style={{ width: "150px", height: "32px" }}></div>

        {/* Placeholder for MultiSelect Country */}
        <div className="ms-3 shimmer" style={{ width: "150px", height: "32px" }}></div>

        {/* Placeholder for MultiSelect Company */}
        <div className="ms-3 shimmer" style={{ width: "150px", height: "32px" }}></div>
      </div>
    </>
  );
};

export default FilterBarSkeleton;